import { FC, HTMLAttributes, ReactNode } from "react";
import Image from "next/image";
import clsx from "clsx";
import HtmlText from "@/sections/common/HtmlText";
import { ITextButton } from "../atoms/buttons/types";
import TButton from "../atoms/buttons/TButton";

// --------------------------------------------------------------------------------

export type IEBooksCard = {
  heading?: string;
  description?: ReactNode;
  image?: { src: string; alt: string };
  button?: ITextButton;
};

export type IEBooksCardProps = HTMLAttributes<HTMLDivElement> &
  IEBooksCard & {};

const EBooksCard: FC<IEBooksCardProps> = (props) => {
  const { heading, description, image, className, button, ...other } = props;

  return (
    <div
      className={clsx(
        "group h-full bg-white transition-all duration-[1200ms] ease-out hover:bg-primary-100",
        className,
      )}
      {...other}
    >
      <div className="h-64 w-auto lg:h-72 xl:h-[336px]">
        {image && (
          <Image
            src={image.src}
            alt={image.alt}
            className="mx-auto !h-full w-48 object-cover lg:w-52 xl:w-[276px]"
            width={276}
            height={366}
          />
        )}
      </div>

      <div className="min-h-28 bg-white md:min-h-[165px] lg:min-h-[210px] xl:min-h-[202px]">
        <div className="h-fit min-h-[130px] bg-white p-4 transition-all duration-[1200ms] ease-out group-hover:bg-primary-900 md:px-5 md:py-6 lg:min-h-40">
          <div className="relative">
            {heading && (
              <h2 className="mb-4 line-clamp-2 text-lg font-medium text-black-900 transition-all duration-[600ms] ease-out group-hover:text-white lg:mb-6 lg:text-h6 xl:text-h5">
                {heading}
              </h2>
            )}

            {button && (
              <TButton
                id={button.id}
                className="bottom-0 z-50 opacity-0 transition-opacity duration-[1200ms] ease-out group-hover:opacity-100"
                variant={button.variant}
                href={button.link}
                target={button.target}
                radius={button.radius}
              >
                {button.text}
              </TButton>
            )}
          </div>
          {description && (
            <HtmlText className="-mt-11 line-clamp-2 opacity-100 group-hover:opacity-0 group-hover:prose-p:transition-all group-hover:prose-p:duration-[600ms] group-hover:prose-p:ease-out lg:line-clamp-3">
              {description}
            </HtmlText>
          )}
        </div>
      </div>
    </div>
  );
};

export default EBooksCard;
